// extracted by mini-css-extract-plugin
export var bodyRow = "_gm-d";
export var cardColumns = "_gm-e";
export var ellipsesOverflow = "_gm-2";
export var flatBottomCorners = "_gm-3";
export var flatTopCorners = "_gm-4";
export var headerActionsDropdown = "_gm-f";
export var headerBottomRow = "_gm-c";
export var headerTopRow = "_gm-b";
export var orderDetailsWrapper = "_gm-0";
export var orderInfoContainer = "_gm-1";
export var productDetails = "_gm-9";
export var productImage = "_gm-5";
export var responsiveTable = "_gm-8";
export var shipmentContainer = "_gm-a";
export var tableBottomLeft = "_gm-6";
export var tableBottomRight = "_gm-7";